import { render, staticRenderFns } from "./mdc-subtitle2.vue?vue&type=template&id=77551494&"
import script from "./mdc-subtitle2.vue?vue&type=script&lang=ts&"
export * from "./mdc-subtitle2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports